import { Autocomplete, TextField, Typography } from '@mui/material'
import React, { Fragment, memo } from 'react'

const CustomdropDown = ({title, id, data, optionLabel, optionEqual, onchange, errorMsg, helperText, placeholder, value,}) => {
  return (
   <Fragment>
    <Typography variant='body1' fontSize={17}  mb={0.8}>{title}</Typography>
    <Autocomplete 
    id={id}
    name={id}
    size='small'
    options={data}
    autoComplete={false}
    getOptionLabel={optionLabel}
    value={value}
    onChange={onchange}
    isOptionEqualToValue={optionEqual}
    renderInput={(params)=>(
        <TextField 
        {...params}
        autoComplete='off'
        placeholder={placeholder}
        error={errorMsg}
        helperText={helperText}
        />
    )}
    />
   </Fragment>
  )
}

export default memo(CustomdropDown)